import type { Mission } from '../missions.ts'

export const usmc: Mission = {
  id: "usmc",
  name: "U.S. Marine Corps",
  short: "USMC",
  call: "Marines",
  kind: "subagency",
  parent: "dod",
  url: "https://www.marines.mil/",
  established: 1775,
  palette: {
    primary: "#940000",
    secondary: "#001e2e",
    accent: "#84754e",
  },
  colorSource: {
    kind: "brand-guide",
    url: "https://www.marines.mil/Style-Guide/",
  },
  motif: "globe",
  mission: {
    text: "As America's expeditionary force in readiness, we are trained and equipped to quickly respond to threats against our nation.",
    url: "https://www.marines.mil/The-Corps/",
  },
  fact: {
    text: "On November 10, 1775, the Continental Congress resolved that two battalions of Marines be raised, the Corps' birthday.",
    url: "https://www.usmcu.edu/Research/Marine-Corps-History-Division/Frequently-Requested-Topics/Historical-Documents-Orders-and-Speeches/Resolution-Establishing-the-Continental-Marines/",
  },
  seal: {
    file: "public/seals/usmc.svg",
    source: "https://commons.wikimedia.org/wiki/File:Seal_of_the_United_States_Marine_Corps.svg",
  },
  logo: {
    file: "public/logos/usmc.png",
    source: "https://commons.wikimedia.org/wiki/File:Eagle,_Globe,_and_Anchor.svg",
  },
  identifier: {
    about: "https://www.marines.mil/The-Corps/",
    accessibility: "https://dodcio.defense.gov/DoDSection508/Std_Stmt.aspx",
    foia: "https://www.hqmc.marines.mil/Agencies/USMC-FOIA/",
    noFear: "https://prhome.defense.gov/NoFear/",
    oig: "https://www.igmc.marines.mil/",
    performance: "https://www.performance.gov/agencies/dod",
    privacy: "https://www.marines.mil/Privacy-Policy",
  },
  media: {
    photos: [
      {
        file: "/media/usmc-ospreys-sydney.jpg",
        small: "/media/usmc-ospreys-sydney-sm.jpg",
        alt: "Three MV-22B Osprey tiltrotor aircraft fly in formation above the sprawling city of Sydney, Australia.",
        title: "MV-22B Ospreys of VMM-265 fly above Sydney, Australia, June 29, 2017",
        creator: "Staff Sgt. T. T. Parish, U.S. Marine Corps",
        source: "https://commons.wikimedia.org/wiki/File:MV-22B_Osprey_flies_over_Sydney_Harbour_4.jpg",
        license: "Public domain (U.S. government work)",
      },
      {
        file: "/media/usmc-ospreys-miramar.jpg",
        small: "/media/usmc-ospreys-miramar-sm.jpg",
        alt: "Two MV-22 Ospreys silhouetted on the flight line against an orange and blue sunset sky.",
        title: "MV-22 Ospreys on the flight line at Marine Corps Air Station Miramar, California, June 14, 2006",
        creator: "U.S. Marine Corps",
        source: "https://commons.wikimedia.org/wiki/File:USMC-05725.jpg",
        license: "Public domain (U.S. government work)",
      },
    ],
  },
}
